import policies from "./policies"
import settings from "./settings"
import users from "@/modules/users/api/"

export default {
	// TODO: slowly delete from here, all apis should be only in modules
	users,
	policies,
	settings
}
